import * as React from "react";

function SvgLeafletDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M11.165 2.25a2.75 2.75 0 012.693 2.193l.03.168.09.639H19a2.75 2.75 0 012.745 2.582L21.75 8v11a2.75 2.75 0 01-2.582 2.745L19 21.75h-6.794a2.74 2.74 0 01-1.375-.368l-.017-.01a2.743 2.743 0 01-1.301-1.816l-.03-.167-.234-1.639H5a2.75 2.75 0 01-2.745-2.582L2.25 15V5a2.75 2.75 0 012.582-2.745L5 2.25h6.165zm1.923 15.5h-2.324l.205 1.427c.026.186.092.356.189.505l1.93-1.932zm-1.923-14H5a1.25 1.25 0 00-1.244 1.122L3.75 5v10c0 .648.491 1.18 1.122 1.244L5 16.25h9.027l-.01-.134-1.614-11.293a1.253 1.253 0 00-1.115-1.067l-.123-.006zm-.265 9a.75.75 0 01.102 1.493l-.102.007H6.5a.75.75 0 01-.102-1.493l.102-.007h4.4zm-.88-3.5a.75.75 0 01.102 1.493l-.102.007H6.5a.75.75 0 01-.102-1.493L6.5 9.25h3.52zm-.88-3.5a.75.75 0 01.102 1.493l-.102.007H6.5a.75.75 0 01-.102-1.493L6.5 5.75h2.64z"
        />
        <path
          fill="#98DB69"
          d="M14.55 9.25h2.95a.75.75 0 01.102 1.493l-.102.007h-2.735l.285 2h2.45a.75.75 0 01.102 1.493l-.102.007h-2.235l.236 1.654c.057.395.026.792-.084 1.166l-.023.066-.013.063-.032.093-.049.094-.02.048a2.726 2.726 0 01-.421.658l-.136.145-2.013 2.013H19a1.25 1.25 0 001.244-1.122L20.25 19V8a1.25 1.25 0 00-1.122-1.244L19 6.75h-4.807l.357 2.5z"
        />
      </g>
    </svg>
  );
}

export default SvgLeafletDuo;
